import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PermissionAccordion({
  moduleName,
  permissions,
  onPermissionChange,
}) {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${moduleName}-content`}
        id={`${moduleName}-header`}
      >
        <Typography fontWeight="bold">{moduleName}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {["View", "Create", "Edit", "Delete"].map((action) => {
          const lowerAction = action.toLowerCase();

          const isPerkataanView =
            moduleName.toLowerCase() === "perkataan" && action === "View";

          // ✅ 'View' must be checked before others can be interacted with
          const viewChecked = permissions["view"] || false;
          const isDisabled =
            isPerkataanView || (action !== "View" && !viewChecked);

          return (
            <FormControlLabel
              key={action}
              control={
                <Checkbox
                  checked={
                    isPerkataanView ? true : permissions[lowerAction] || false
                  }
                  disabled={isDisabled}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    // ✅ If unchecking 'View', also untick all others
                    if (action === "View" && !checked) {
                      onPermissionChange(moduleName, "view", false);
                      onPermissionChange(moduleName, "create", false);
                      onPermissionChange(moduleName, "edit", false);
                      onPermissionChange(moduleName, "delete", false);
                    } else {
                      onPermissionChange(moduleName, lowerAction, checked);
                    }
                  }}
                />
              }
              label={action}
            />
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}
